import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import React, { useRef, useState } from "react";
import { changeLang } from "../../componets/Language/ChangeLang";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { Toast } from "primereact/toast";
import ScreenLoader from "../../componets/ScreenLoader";
import { DermacationLevels } from "../../constants";

const MoveDelimitations = ({ moveDermacation, isLoading, setmoveDermacation, dermacationForm, isNational, nodeName, setdermacationForm, onMove = () => { } }) => {

	const [delimitation, setDelimitation] = useState(null);
	const toast = useRef(null);
	return (
		<Dialog
			header={dermacationForm?.level === DermacationLevels?.Level4 ? "Move Registration Centre" : "Move Village"}
			style={{ width: "80vw", height: "95vh" }}
			onHide={() => setmoveDermacation(false)}
			footer={
				<div className="flex justify-content-end gap-2">
					<Button label="Cancel" icon="pi pi-times" text onClick={() => setmoveDermacation(false)} />
					<Button
						label="Move"
						icon="pi pi-check"
						disabled={
							dermacationForm.level > DermacationLevels.Level4
								? !(dermacationForm.registrationCenterNAID || dermacationForm.registrationCenterLGID)
								: false
						}
						onClick={onMove}
					/>

				</div>
			}
			className="py-4"
			visible={moveDermacation}
		>
			<ScreenLoader visible={isLoading} />
			<Toast ref={toast} />

			<div className="lg:col-12 md:col-6 col-4">
				Move {dermacationForm?.level === DermacationLevels?.Level4 ? dermacationForm?.registrationCentreName : dermacationForm?.villageName}
				<Divider align="center">
					<h6>{dermacationForm?.level === DermacationLevels?.Level3 ? "From Registration Centre" : " From Village"}</h6>
				</Divider>
				<div className="p-fluid p-grid  section-style-block">
					<div className="p-field p-col-6 p-md-4">
						<label>{isNational ? changeLang.get("national_delimitation.district") : changeLang.get("local_delimitation.district")}</label>
						<div className=" p-inputtext p-component p-filled p-disabled">{dermacationForm?.districtName}</div>
					</div>
					<div className="p-field p-col-6 p-md-4">
						<label>
							{" "}
							{isNational ? changeLang.get("national_delimitation.constituency") : changeLang.get("local_delimitation.council")}
						</label>
						<div className=" p-inputtext p-component p-filled p-disabled">{dermacationForm?.constituencyName}</div>
					</div>
					<div className="p-field p-col-6 p-md-4">
						<label>
							{isNational
								? changeLang.get("national_delimitation.electoralDivision")
								: changeLang.get("local_delimitation.electoralDivision")}
						</label>
						<div className=" p-inputtext p-component p-filled p-disabled">{dermacationForm?.votingDistrictName}</div>
					</div>
					{dermacationForm?.level > DermacationLevels?.Level4 && (
						<div className="p-field p-col-6 p-md-4">
							<label>{changeLang.get("national_delimitation.votingCentre")}</label>
							<div className=" p-inputtext p-component p-filled  p-disabled">{dermacationForm?.registrationCentreName}</div>
						</div>
					)}
				</div>
				<Divider align="center">
					{" "}
					<h6>
						{dermacationForm?.level === DermacationLevels.Level3
							? "Move To Registration Centre"
							: "Move To Village"}
					</h6>
				</Divider>
				<LocalDelimitationNational
					showVillage={false}
					showRegistrationCentre={dermacationForm?.level > DermacationLevels?.Level4}
					setLocalDelimitation ={setDelimitation}
					isNational={isNational}
					onChange={(delimitationID, delimitationLevelID) => {
						setDelimitation({
							delimitationID,
							delimitationLevelID
						});
						if (isNational) {
							setdermacationForm({
								...dermacationForm,
								registrationCenterNAID: delimitationID
							});
						} else {
							setdermacationForm({
								...dermacationForm,

								registrationCenterLGID: delimitationID
							});
						}
					}}
				/>
			</div>
		</Dialog>
	);
};

export default MoveDelimitations;
